<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="600px" :destroy-on-close="true" :before-close="cancel">
    <el-form label-width="100px" ref="form" :model="form" :rules="rules">
      <el-form-item label="物料名称" prop="materialLexiconId">
        <el-select  style="width: 400px;" v-model="form.materialLexiconId" placeholder="请选择物料名称" filterable>
          <el-option v-for="item in LexiconOptions" :key="item.id" :label="item.materialName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入库数量" prop="number">
        <el-input-number style="width: 400px;" size="small" v-model="form.number" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input style="width: 400px;" v-model="form.remark" type="textarea" :autosize="{ minRows: 3}" maxlength="300" show-word-limit placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" class="title" @click="cancel">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>

import {checkNum} from "@/utils/rules";
import {addStock, editStock} from "@/api/dilivery/material/stockIn";
import {getMaterialType} from "@/api/dilivery/material/lexicon";

export default {
  name: "AddEditStockIn",
  props:['showDialog','selectType','selectDetail'],
  data(){
    return{
      title:'',
      LexiconOptions: [],
      form:{
        remark:'',
        materialLexiconId:'',
        number:''
      },
      rules: {
        materialLexiconId: [
          {required: true,message: '请选择物料', trigger: 'change'}
        ],
        number: [
          {required: true, message: '请输入数量', trigger: 'change'},
          {validator:checkNum, trigger: 'change'}
        ]
      }
    }
  },
  watch:{
    selectType:{
      handler(newVal){
        if (newVal){
          if(newVal==='edit'){
            this.title='编辑入库信息'
          }else{
            this.title='添加入库信息'
          }
        }
      },
      immediate:true
    },
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.form.materialLexiconId = newVal.materialLexiconId
          this.form.number = newVal.number
          this.form.remark = newVal.remark
        }
      },
      immediate:true
    },
  },
  mounted() {
    this.getMaterial()
  },
  methods:{
    async getMaterial(){
      try{
        const res = await getMaterialType({})
        if(res.code === 200){
          this.LexiconOptions = res.data
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      this.$refs.form.validate(valid=>{
        if(valid){
          if(this.selectType === 'add'){
            addStock(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('提交成功')
              }
            }).catch(err => {
            })
          }else{
            editStock(this.form).then(res => {
              if (res.code === 200) {
                this.$emit('submit','confirm')
                this.$messageUi.success('修改成功')
              }
            }).catch(err => {
            })
          }
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
